import { memo, useCallback, useState } from 'react';
import { FormSpy } from 'react-final-form';

import { Button } from 'UIPackage/MainModule/components/Button';
import { KnmAttachmentsSigning } from 'KnmPackage/MainModule/components/KnmAttachmentsSigning';

import styles from './ErknmResultDecisionProtocol.module.scss';
import { IKnmFormRef } from '../../../KnmPackage/MainModule/interfaces/IKnmFormRef';
import { KnmLateFieldsRemark } from '../../../KnmPackage/KnmLateFieldsRemarkModule/components/KnmLateFieldsRemark';

interface IErknmResultDecisionProtocolProps {
  attachmentsNumber: number;
  className?: string;
  formRef: IKnmFormRef | undefined;
  isRequired: boolean;
  isWatchOnly: boolean;
  lateFieldName: string | undefined;
  name: string;
  id: string;
}

export const ErknmResultDecisionProtocol = memo(
  ({
    attachmentsNumber,
    className = '',
    formRef,
    isRequired,
    isWatchOnly,
    lateFieldName,
    name,
    id,
  }: IErknmResultDecisionProtocolProps) => {
    const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);

    const openSignModal = useCallback(() => setIsVisibleSignModal(true), []);
    const closeSignModal = useCallback(() => setIsVisibleSignModal(false), []);

    return (
      <div className={`${styles.Wrapper} ${className}`}>
        <div className="shared-group-label">
          Файл протокола
          {lateFieldName && <KnmLateFieldsRemark lateFieldPath={lateFieldName} fieldId={id} />}
          <span className="shared-no-wrap-text">
            <Button
              className="shared-btn-add"
              text="Добавить"
              variant="link"
              color="primary"
              type="button"
              id="fileAddButton"
              disabled={isWatchOnly || attachmentsNumber > 0}
              onClick={openSignModal}
            />
          </span>
        </div>
        <FormSpy subscription={{ errors: true, touched: true }}>
          {props => {
            const reasonsFieldError = props.errors?.resultDecisions?.find(
              (item: { protocol: { attachments: { [x: string]: string } } }) => {
                return item?.protocol?.attachments;
              },
            );

            if (reasonsFieldError) {
              return <p className="shared-input-error">Поле не может быть пустым</p>;
            }

            return null;
          }}
        </FormSpy>
        <div className={styles.AttachmentList}>
          <KnmAttachmentsSigning
            isWatchOnly={isWatchOnly}
            name={name}
            isRequired={isRequired}
            isVisibleSignModal={isVisibleSignModal}
            closeSignModal={closeSignModal}
            acceptedFiles={'.pdf,.png,.jpeg,.ktd,.rtf,.rar,.zip'}
            formRef={formRef}
          />
        </div>
      </div>
    );
  },
);
